import React, { Component } from 'react';
import { connect } from 'react-redux';
import { do_action } from '../../actions';
import DateInput from '../Common/DateInput'
import SelectForm from '../Common/SelectForm'
import SelectFormSort from '../Common/SelectFromSort'
import {NUMBER_YEAR_OPERATION, YEAR_OF_WARRANTY, PAID_UP_CAPITAL, CERTIFICATIONS, INSURANCE_PROVIDER} from '../../data/config'
import UploadListImage from '../Common/UploadListImage'

class Contractor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            form: {}
        }
    }

    componentWillMount = () => {
        do_action('get_contractor_detail', { id: this.props.vendor._id })
            .then(result => {
                if (result.signal) {
                    this.setState({ form: result.data.vendor_contractor_detail_id })
                } else {
                    console.log(result);
                }
            })
            .catch(err => console.log(err))
    }

    editDetail = (property, event) => {
        let { form } = this.state
        form[property] = event.target.value
        this.setState({ form })
        this.props.updateForm(property, event.target.value)
    }

    handleChangeSelect = (name, value) => {
        let { form } = this.state
        form[name] = value
        this.setState({ form })
        this.props.updateForm(name, value)
    }

    changeDate(value, key) {
        try {
            let time = value.format('DD/MM/YYYY')
            let { form } = this.state
            form[key] = time
            this.setState({ form })
            this.props.updateForm(key, time)
        } catch (err) {
            console.log(err)
        }
    }

    updateImage = (list_image) => {
        let { form } = this.state
        form.list_image = list_image
        this.setState({ form })
        this.props.updateForm('list_image', list_image)
    }

    render() {
        let { form } = this.state;
        if (!form._id) return ''

        let list_image = form.list_image ? JSON.parse(form.list_image) : []

        return (
            <div>
                <p className="tit fontMedium">Excerpt</p>
                <div className="form-group">
                    <textarea value={form.excerpt ? form.excerpt : ''} row={5} onChange={this.editDetail.bind(this, 'excerpt')} className="form-control form-control-mix" />
                </div>
                <p className="tit fontMedium">Date Of Registration</p>
                <div className="form-group">
                    <DateInput timeInput={form.date_of_regis ? form.date_of_regis : ''} name="date_of_regis" changeDate={this.changeDate.bind(this)}/>
                </div>
                <p className="tit fontMedium">Date Of Information Obtained</p>
                <div className="form-group">
                    <DateInput timeInput={form.date_of_info_obt_2 ? form.date_of_info_obt_2 : ''} name="date_of_info_obt_2" changeDate={this.changeDate.bind(this)}/>
                </div>
                <p className="tit fontMedium">Company name</p>
                <div className="form-group">
                    <input type="text" value={form.company_name ? form.company_name : ''} onChange={this.editDetail.bind(this, 'company_name')} className="form-control form-control-mix" readOnly={true}/>
                </div>
                <p className="tit fontMedium">UEN</p>
                <div className="form-group">
                    <input type="text" value={form.uen ? form.uen : ''} onChange={this.editDetail.bind(this, 'uen')} className="form-control form-control-mix" />
                </div>
                <p className="tit fontMedium">Address</p>
                <div className="form-group">
                    <input type="text" value={form.address ? form.address : ''} onChange={this.editDetail.bind(this, 'address')} className="form-control form-control-mix" />
                </div>
                <p className="tit fontMedium">Principal Activity 1</p>
                <div className="form-group">
                    <input type="text" value={form.principal_activity_1 ? form.principal_activity_1 : ''} onChange={this.editDetail.bind(this, 'principal_activity_1')} className="form-control form-control-mix" />
                </div>
                <p className="tit fontMedium">Principal Activity 2</p>
                <div className="form-group">
                    <input type="text" value={form.principal_activity_2 ? form.principal_activity_2 : ''} onChange={this.editDetail.bind(this, 'principal_activity_2')} className="form-control form-control-mix" />
                </div>
                <p className="tit fontMedium">Incorporation Date</p>
                <div className="form-group">
                    <DateInput timeInput={form.incorporation_date ? form.incorporation_date : ''} name="incorporation_date" changeDate={this.changeDate.bind(this)}/>
                </div>
                <p className="tit fontMedium">No. of yrs in Operation</p>
                <SelectFormSort 
                    name="no_of_yrs_in_opreration" 
                    value={form.no_of_yrs_in_opreration ? form.no_of_yrs_in_opreration : ''} 
                    data={NUMBER_YEAR_OPERATION} 
                    onChange={this.handleChangeSelect.bind(this)} 
                />
                <p className="tit fontMedium">No. of times Company changes Name</p>
                <div className="form-group">
                    <input type="number" value={form.no_of_times_company_change_name ? form.no_of_times_company_change_name : ''} onChange={this.editDetail.bind(this, 'no_of_times_company_change_name')} className="form-control form-control-mix" />
                </div>
                
                <p className="tit fontMedium">Paid-up Capital</p>
                <SelectFormSort 
                    name="paid_up_capital" 
                    value={form.paid_up_capital ? form.paid_up_capital : ''} 
                    data={PAID_UP_CAPITAL} 
                    onChange={this.handleChangeSelect.bind(this)} 
                />

                <p className="tit fontMedium">Company office/factory/workshop photos</p>
                <div className="form-group">
                    <input type="text" value={form.company_office ? form.company_office : ''} onChange={this.editDetail.bind(this, 'company_office')} className="form-control form-control-mix" />
                </div>

                <p className="tit fontMedium">No. of workers</p>
                <div className="form-group">
                    <input type="number" value={form.no_of_workers ? form.no_of_workers : ''} onChange={this.editDetail.bind(this, 'no_of_workers')} className="form-control form-control-mix" />
                </div>

                <p className="tit fontMedium">Years of Warranty</p>
                <SelectFormSort 
                    name="years_of_warranty" 
                    value={form.years_of_warranty ? form.years_of_warranty : ''} 
                    data={YEAR_OF_WARRANTY} 
                    onChange={this.handleChangeSelect.bind(this)} 
                />

                <p className="tit fontMedium">Public Liability Insurance</p>
                <div className="form-group">
                    <input type="text" value={form.public_liability_insurance ? form.public_liability_insurance : ''} onChange={this.editDetail.bind(this, 'public_liability_insurance')} className="form-control form-control-mix" />
                </div>

                <p className="tit fontMedium">Contractor All Risk</p>
                <div className="form-group">
                    <input type="text" value={form.contractor_all_risk ? form.contractor_all_risk : ''} onChange={this.editDetail.bind(this, 'contractor_all_risk')} className="form-control form-control-mix" />
                </div>
                <p className="tit fontMedium">Performance Bond</p>
                <div className="form-group">
                    <input type="text" value={form.performance_bond ? form.performance_bond : ''} onChange={this.editDetail.bind(this, 'performance_bond')} className="form-control form-control-mix" />
                </div>
                <p className="tit fontMedium">Professional Indemity Insurance (For ID)</p>
                <div className="form-group">
                    <input type="text" value={form.professional_indemity_insurance ? form.professional_indemity_insurance : ''} onChange={this.editDetail.bind(this, 'professional_indemity_insurance')} className="form-control form-control-mix" />
                </div>
                <p className="tit fontMedium">Workman Compensation</p>
                <div className="form-group">
                    <input type="text" value={form.workman_compensation ? form.workman_compensation : ''} onChange={this.editDetail.bind(this, 'workman_compensation')} className="form-control form-control-mix" />
                </div>
                
                <p className="tit fontMedium">Insurance Provider</p>
                <SelectForm 
                    name="insurance_provider" 
                    value={form.insurance_provider ? form.insurance_provider : ''} 
                    data={INSURANCE_PROVIDER} 
                    onChange={this.handleChangeSelect.bind(this)} 
                />

                <p className="tit fontMedium">Certifications</p>
                <SelectForm 
                    name="certifications" 
                    value={form.certifications ? form.certifications : ''} 
                    data={CERTIFICATIONS} 
                    onChange={this.handleChangeSelect.bind(this)} 
                />
                <p className="tit fontMedium">List Image</p>
                <div className="form-group">
                    <UploadListImage 
                        image={list_image}
                        updateImage={this.updateImage}
                    />
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { vendor } = state;
    return {
        vendor
    }
}

export default connect(mapStateToProps)(Contractor);